export default "__VITE_ASSET__a1d58dda__"